/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { SRLWrapper, useLightbox } from 'simple-react-lightbox';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages, faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import Button from './Button';
import getImageData from '../helpers/ImageHelper';
import NMImage from './shared/NMImage';

function Gallery({ trip }) {
  const { openLightbox } = useLightbox();
  const images = (trip?.attributes?.images?.data || []).map((image) =>
    getImageData({ data: image }),
  );

  const previewImage = getImageData(trip?.attributes?.preview_image);
  const previewList = images.slice(0, 4);
  const fullImageList = [previewImage, ...images].filter((image) => image.src);
  return (
    <div className="relative w-full">
      <div className="relative md:flex">
        <Carousel
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <button
                className="absolute top-[40%] right-2 z-20 h-[5%] w-[5%] font-medium"
                type="button"
                onClick={onClickHandler}
                title={label}
              >
                <FontAwesomeIcon icon={faAngleRight} className="text-4xl text-white" />
              </button>
            )
          }
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                className="absolute top-[40%] left-2 z-20 h-[5%] w-[5%] font-medium"
                type="button"
                onClick={onClickHandler}
                title={label}
              >
                <FontAwesomeIcon icon={faAngleLeft} className="text-4xl text-white" />
              </button>
            )
          }
          autoPlay
          interval="5000"
          infiniteLoop
          showArrows
          showThumbs={false}
          showStatus={false}
          className="mx-auto flex md:hidden lg:hidden xl:hidden"
        >
          {fullImageList.map((img) => (
            <div key={`carousel-image-${img.id}`} className="w-full">
              <NMImage src={img.src} alt={img.alt} className="" width="768" height="506" />
            </div>
          ))}
        </Carousel>
      </div>
      <div className="relative hidden md:block cursor-pointer">
        <div
          onClick={() => openLightbox()}
          className="grid w-full grid-flow-row-dense grid-cols-4 grid-rows-2 content-center gap-x-4 gap-y-2"
        >
          <div className="col-span-2 row-span-2">
            {previewImage.src && (
              <NMImage
                src={previewImage.src}
                className="md:rounded-xl"
                width="632"
                height="438"
                alt={previewImage.alt}
              />
            )}
          </div>
          {previewList.map((img, index) => (
            <div key={`carousel-${index}`}>
              <NMImage src={img.src} alt="" className="rounded-xl" width="632" height="433" />
            </div>
          ))}
        </div>
        <SRLWrapper>
          {fullImageList.map((img, index) => (
            <div key={`srl-wrapper-${index}`} className="hidden">
              <NMImage src={img.src} alt="" className="rounded-xl" width="632" height="433" />
            </div>
          ))}
        </SRLWrapper>
        <div className="absolute bottom-6 right-6 w-[198px]">
          <Button onClick={() => openLightbox()} className="bg-white flex items-center py-[14px] px-[22px]">
            <FontAwesomeIcon icon={faImages} className="text-black mr-2 inline-block " />
            <span className="text-black inline-block font-poppins text-base">Show all photos</span>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
